export const REMOVE_TRIGGERS_FILTERS = 'REMOVE_TRIGGERS_FILTERS';

export const removeTriggersFilters = (context, filterType, filterValues) => ({
  type: REMOVE_TRIGGERS_FILTERS,
  context,
  filterType,
  filterValues,
});
